module.exports = __webpack_public_path__ + "img/3.408ff050.jpg";